import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import es from './locales/es.json';
import pt from './locales/pt.json';
import { isCoreReadOnly } from '@/lib/core-cutover';
import { resolveDisplayLang, type SupportedLang } from './display-language';

export { SUPPORTED_LANGS, LANG_LABELS, resolveDisplayLang } from './display-language';
export type { SupportedLang } from './display-language';

/** The language the interface is shown in right now (see display-language.ts). */
export function displayLanguage(): SupportedLang {
  return resolveDisplayLang(i18n.resolvedLanguage, i18n.language);
}

// Keep <html lang> on the language the interface is actually shown in, from
// start-up and on every change, so screen readers use the right
// pronunciation. index.html ships lang="en" only for the first paint.
function syncDocumentLang(): void {
  if (typeof document !== 'undefined') document.documentElement.lang = displayLanguage();
}
i18n.on('languageChanged', syncDocumentLang);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      pt: { translation: pt },
    },
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'adia-lang',
      caches: isCoreReadOnly() ? [] : ['localStorage'],
    },
  });
syncDocumentLang();

export default i18n;
